import AppShell from '@ben/orion/app-shell';
import { Outlet } from 'react-router-dom';
import { useTheme } from 'styled-components';
import LeftNavigation from '../layout';

const LeftNavLayout = () => {
  const theme = useTheme();

  return (
    <AppShell
      pageBgColor={theme.palette.neutral[10]}
      leftNavigation={<LeftNavigation />}
    >
      <Outlet />
    </AppShell>
  );
};

export default LeftNavLayout;
